module.exports = __webpack_public_path__ + "static/img/icon_dropdown_16.2645a9c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/educal/icon_dropdown_16.svg
// module id = 8Crd
// module chunks = 10